import React from 'react';
import Page from '../../components/Page';
import { DollarSign } from 'lucide-react';

const CostsOverviewPage: React.FC = () => {
  return (
    <Page
      title="💰 Análise de Custos - Visão Geral"
      subtitle="Dashboard principal da Análise de Custos"
      onRefresh={() => window.location.reload()}
    >
      <div className="w-full h-full flex items-center justify-center">
        <div className="text-center">
          <DollarSign 
            className="h-16 w-16 mx-auto mb-4" 
            style={{ color: 'var(--primary)' }}
          />
          <h2 
            className="text-2xl font-semibold mb-2"
            style={{ color: 'var(--text-primary)' }}
          >
            Análise de Custos - Em Desenvolvimento
          </h2>
          <p 
            style={{ color: 'var(--text-secondary)' }}
          >
            Esta página será implementada em breve
          </p>
        </div>
      </div>
    </Page>
  );
};

export default CostsOverviewPage;
